module.exports = __webpack_public_path__ + "static/img/10.aabe5592.jpg";